//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EmailTemplateType } from './Enums';

export class EmailPreviewInputItem extends ItemBase {
    TemplateType: EmailTemplateType = EmailTemplateType.Custom;
    SubjectWithPlaceholders: string | null = null;
    BodyWithPlaceholders: string | null = null;
    IgnorePlaceholderErrors: boolean = false;

    constructor(initializer?: Partial<EmailPreviewInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EmailPreviewInputItem";
}
